export default __webpack_public_path__ + "static/switch-dark-mode-d599bc38494564eaf1e68648179112ce.mp4";